import React, {useContext} from 'react';
import {translate} from '../../helpers/base';
import {AppContext} from '../../contexts/AppContext';

const Discount = () => {
    const {
        selectedFilters,
        handleSimpleFilterChange,
    } = useContext(AppContext);

    const isChecked = selectedFilters.discount === 1;

    return (
        <div className="checkbox">
            <label>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => handleSimpleFilterChange('discount', !isChecked)}
                />
                <span></span>
                <div>{translate('accommodation-overview.filter.misc.discount.label')}</div>
            </label>
        </div>
    );
};

export default Discount;
